import React from 'react'
import { TaskList } from 'src/pages/worldCup2026/tasks/list'

export const WorldCup2026TasksPage = () => {
  return <TaskList />
}
